import { CommonModule, ViewportScroller } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Component, inject, signal } from '@angular/core'
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { SessionService } from './shared/session/session-service'
import { GeolocationService } from '@corporate-tailwind/geolocation'


@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    protected appVersion = signal("")
    private http = inject(HttpClient)
    private geolocationService = inject(GeolocationService)
    private sessionService = inject(SessionService);

    ngOnInit() {
        // this.http.get(`api/version`, { responseType: 'text' }).subscribe((response: string) => {
        //     this.appVersion.set(response);
        // });        
        // this.sessionService.Update({
        //     sessionId: "",
        //     requestType: 'AppInit',
        //     currentUrl: window.location.href,
        //     wizardData: null
        // }).subscribe();
    }

    private previousUrl: string | null = null;

    constructor(
        public router: Router,
        private viewportScroller: ViewportScroller
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                const currentUrl = event.urlAfterRedirects
                // Scroll to top ONLY if navigating to a different route (not on refresh)
                if (this.previousUrl && this.previousUrl !== currentUrl) {
                    this.viewportScroller.scrollToPosition([0, 0])
                }
                this.previousUrl = currentUrl


                this.geolocationService.getCurrentPosition().subscribe({
                    next: (position) => console.log(position),
                    error: (err) => console.error('Erreur géolocalisation :', err),
                })
            }
        })
    }

}

// @Component({
//     selector: 'app-root',
//     imports: [RouterOutlet, CommonModule, LoaderComponent, Page401Component],
//     template: `
// @if (userStore.loading()) {
//     <app-loader></app-loader>
// }
// @else if (!userStore.loading() && userStore.user()?.isAuthorized) {
//     <router-outlet></router-outlet>
// }
// @else if (!userStore.loading() && !userStore.user()?.isAuthorized) {
//     <app-page-401> </app-page-401>
// }
// `,
//     styleUrl: './app.scss'
// })
// export class App {
//     userStore = inject(UserStore)

//     constructor() {
//         this.userStore.loadUser()
//     }
// }
